const AppConsts = {
    googleMapsApiKey: 'AIzaSyB13ypzLGkOmyOQtO5KuhIOZ503I3UtVJw',
    stripePublicKey: 'pk_live_51HxE9pAWG8Sp4hLiRm60Vk0biaD4PUBBzrDWCblg14QUNEaeCZCZzPWTr8WTiR26u7m2ITI3JaJtrxCbT1P0dO0w00k15G8NBc',
};

export default AppConsts;
